import * as React from 'react';

export interface ISubmitMessageProps {
    children: React.ReactNode;
    className?: string;
    roleForTest?: string;
    removeMargins?: boolean;
}


export const SubmitMessage: React.FC<ISubmitMessageProps> = (props: ISubmitMessageProps) => {
    return <div className={`submit-message ${props.className ? props.className : ''} ${props.removeMargins ? " no-margins" : ''}`} data-test-role={props.roleForTest}>
        {props.children}
    </div>
}